    export type IGeneralInfo = {
        'status': string,
        'payment_type': string,
        'reg_type': string,
        'vendor': string,
        'event_title': string,
        'event_id': string,
        'pay_date': string,
        'final_price': number,
        'promo_code ': string
    };

    export enum GENERAL_INFO_ACTION_TYPE {    
        INFO_SELECT = 'general-info/info-select',
        INFO_RESET = 'general-info/info-reset',
        REG_TYPE = 'general-info/reg-type',
        FINAL_PRICE_UPDATE = 'general-info/final-price-update',
        EVENT_SELECT = 'general-info/event-select'
    };

    export type IGeneralInfoState = {
        selected: IGeneralInfo | undefined  
    };

    function getGeneralInfoInitialState(): IGeneralInfoState {
        return {
            selected: {
                'status': 'initiated',
                'payment_type': 'offline',
                'reg_type': '',
                'vendor': 'stripe',
                'event_title': '',
                'event_id': '',
                'pay_date': '',
                'final_price': 0,
                'promo_code ': ''
            }       
        };
    }

    export function generalInfoReducer(state = getGeneralInfoInitialState(), action: {
                type: GENERAL_INFO_ACTION_TYPE, payload: any}) {
        switch (action.type) {
            case GENERAL_INFO_ACTION_TYPE.INFO_SELECT:
                return {...state, selected: action.payload};
            case GENERAL_INFO_ACTION_TYPE.REG_TYPE:
                return {...state, selected: {...state.selected, 'reg_type': action.payload}};
            case GENERAL_INFO_ACTION_TYPE.FINAL_PRICE_UPDATE:
                return {...state, selected: {...state.selected, 'final_price': action.payload}};
            case GENERAL_INFO_ACTION_TYPE.EVENT_SELECT:
                    return {...state, selected: {...state.selected, ...action.payload}};    
            case GENERAL_INFO_ACTION_TYPE.INFO_RESET:
                    return {...state, selected: getGeneralInfoInitialState().selected};        
            default:
                return state;
        }
    }